import { sprintf } from 'sprintf-js';

export function getCmsTotalReactionsText(totalReactions: number) {
  if (totalReactions === 0) {
    return getText('Be the first to like this post');
  }

  if (totalReactions === 1) {
    return sprintf(getText('%(totalReactions)s person reacted'), {
      totalReactions,
    });
  }

  if (totalReactions > 1) {
    return sprintf(getText('%(totalReactions)s people reacted'), {
      totalReactions,
    });
  }
}
